/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authstartheading2Inputs */

const en_authstartheading2 = /** @type {(inputs: Authstartheading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One more step`)
};

const pt_authstartheading2 = /** @type {(inputs: Authstartheading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais um passo`)
};

/**
* | output |
* | --- |
* | "One more step" |
*
* @param {Authstartheading2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const authstartheading2 = /** @type {((inputs?: Authstartheading2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authstartheading2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_authstartheading2(inputs)
	return pt_authstartheading2(inputs)
});
export { authstartheading2 as "authStartHeading" }